import { type UpdatedAtClassNames } from './useTableUpdatedAt';

export const CLASS_NAMES: UpdatedAtClassNames = {
  wrapper: 'flex flex-row',
  text: 'text-16-20 text-neutral-900 text-left',
};
